import { RGBA } from './rgba';

export const getStringToRGBA = (str: string) => {
  const sum = str.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const rgba = new RGBA((sum * 7) % 256, (sum * 13) % 256, (sum * 17) % 256);

  return rgba;
};
